var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.24977C1 4.00709 1.98497 2.99969 3.2 2.99969H20.8C22.01 2.99969 23 4.00098 23 5.24977V9.74993C21.79 9.74993 20.8 10.7512 20.8 12C20.8 13.2427 21.785 14.2501 23 14.2501V18.7502C23 19.9929 22.015 21.0003 20.8 21.0003H3.2C1.98497 21.0003 1 19.9929 1 18.7502V14.2501C2.21503 14.2501 3.2 13.2427 3.2 12C3.2 10.7625 2.221 9.74993 1 9.74993V5.24977ZM11.79 14.7003L15.37 17.0004L14.28 12.8902L17.57 10.2001L13.33 9.95014L11.79 6L10.24 9.94014L6 10.1901L9.29 12.8802L8.21 17.0004L11.79 14.7003Z",
    fill: "#5D6B72"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-promotion",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-promotion)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D6B72",
    d: "M0 0h24v23.999H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/Promotions.f0f9ef5a.svg";
export { ForwardRef as ReactComponent };